import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Layout from 'components/Layout/Layout';
import LoadingScreen from 'components/__SHARED__/LoadingScreen/LoadingScreen';
import AuthContextProvider from 'context/authContext/AuthContext';
import { IApis } from 'library/Apis';
import { TopLoader } from 'plataforma-fundacao-componentes';
import 'plataforma-fundacao-componentes/dist/index.css';
import CountdownProvider from 'providers/CountdownProvider';
import { Suspense, useEffect } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { getStore, history } from 'store/Store';
import { addGTag } from 'helpers/utils/Gtag';
import { ReactQueryDevtoolsProduction } from './helpers/utils/reactQuery';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { addHandTalk } from 'helpers/utils/HandTalk';

export default function App({ env }: { env: IApis }) {
  useEffect(() => {
    if (env.gtag) {
      addGTag();
    }
    if (env.handtalk) {
      addHandTalk();
    }
  }, [env]);

  const queryClient = new QueryClient();

  const showDevTools = process.env.REACT_SHOW_DEV_TOOLS ?? false;

  if (env && env.environment) {
    return (
      <QueryClientProvider client={queryClient}>
        <Provider store={getStore(env.environment) as any}>
          <AuthContextProvider currentEnv={env}>
            <Suspense fallback={<TopLoader opened />}>
              <CountdownProvider>
                <Router history={history}>
                  <Layout />
                </Router>
              </CountdownProvider>
            </Suspense>
          </AuthContextProvider>
        </Provider>
        <ReactQueryDevtools
          client={queryClient}
          initialIsOpen={false}
          position={'right'}
          buttonPosition={'bottom-right'}
        />
        {showDevTools && (
          <Suspense fallback={undefined}>
            <ReactQueryDevtoolsProduction
              client={queryClient}
              initialIsOpen={false}
              position={'right'}
              buttonPosition={'bottom-right'}
            />
          </Suspense>
        )}
      </QueryClientProvider>
    );
  }

  return <LoadingScreen />;
}
